import { useEffect, useState } from "react";
import { Cake, MessageCircle, X } from "lucide-react";

import { api } from "@/api";
import { useAuth } from "@/auth";

const formatDate = (iso) => new Date(`${iso}T00:00:00`).toLocaleDateString("it-CH", { weekday: "long", day: "numeric", month: "long" });

// Impronta dell'elenco compleanni: il popup ricompare solo se ci sono compleanni NUOVI
// rispetto all'ultima chiusura (i già visti restano consultabili senza popup).
const fingerprintOf = (items) => items.map((item) => `${item.client_id}:${item.contact_name}:${item.next_birthday}`).sort().join("|");

export const BirthdayReminder = () => {
  const { user } = useAuth();
  const canSee = ["admin", "responsabile", "coordinatore_commerciale"].includes(user.role);
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!canSee) return;
    api.get("/clients/birthdays/upcoming").then(({ data }) => {
      if (!data.length) return;
      if (localStorage.getItem("birthday-popup-seen") === fingerprintOf(data)) return;
      setItems(data);
      setOpen(true);
    }).catch(() => null);
  }, [canSee]);
  const close = () => { localStorage.setItem("birthday-popup-seen", fingerprintOf(items)); setOpen(false); };
  if (!open) return null;
  return <div className="modal-backdrop" data-testid="birthday-popup">
    <div className="completion-modal birthday-modal">
      <div className="section-heading"><div><p className="eyebrow">PROMEMORIA</p><h2 data-testid="birthday-popup-title">Compleanni in arrivo</h2></div><Cake size={22} /></div>
      <p className="birthday-subtitle" data-testid="birthday-popup-subtitle">Familiari e referenti dei clienti che festeggiano da oggi a fine del prossimo mese. Una volta chiuso, ricompare solo con compleanni nuovi.</p>
      <ul className="birthday-list" data-testid="birthday-list">
        {items.map((item, index) => <li key={`${item.client_id}-${index}`} data-testid={`birthday-item-${index}`}>
          <strong data-testid={`birthday-contact-${index}`}>{item.contact_name}</strong>
          <span>{item.contact_role} · {item.client_name}</span>
          <em data-testid={`birthday-date-${index}`}>{formatDate(item.next_birthday)} · {item.days_until === 0 ? "OGGI!" : item.days_until === 1 ? "domani" : `fra ${item.days_until} giorni`}{item.turning_age > 0 ? ` · compie ${item.turning_age} anni` : ""}</em>
          {item.wa_phone && item.wa_message && <button data-testid={`birthday-whatsapp-${index}`} type="button" onClick={() => window.open(`https://wa.me/${item.wa_phone}?text=${encodeURIComponent(item.wa_message)}`, "_blank", "noopener")} style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 12px", borderRadius: 999, border: "none", cursor: "pointer", background: "#25D366", color: "#07230f", fontWeight: 700, fontSize: 12, marginTop: 6, width: "fit-content" }}><MessageCircle size={14} />Invia auguri su WhatsApp</button>}
        </li>)}
      </ul>
      <div className="modal-actions"><button data-testid="birthday-popup-close" className="primary-button" type="button" onClick={close}><X size={16} />Chiudi</button></div>
    </div>
  </div>;
};

export default BirthdayReminder;
